module.exports = __webpack_public_path__ + "static/media/img16.7c930dc4.jpg";